import React from 'react';
import styled from 'styled-components';

import { Empty } from 'antd';
import PropTypes from 'prop-types';

const StyledImgDiv = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 80px;
  width: 100%;
`;

export const TableEmpty = ({ colSpan, message, ...props }) => {
  return (
    <tbody {...props}>
      <tr key="table-empty-row-1">
        <td colSpan={colSpan} key="table-empty-td-1">
          <StyledImgDiv>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span>{message}</span>} />
          </StyledImgDiv>
        </td>
      </tr>
    </tbody>
  );
};

TableEmpty.propTypes = {
  colSpan: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
};
